import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'center',
    paddingTop: defaultTheme.spacing.xxl,
  }),
);

export const LoginWrapper = styled(Wrapper)(() =>
  mq({
    '& > p': {
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
      fontWeight: 'bold',
    },
    '& > span': {
      fontSize: defaultTheme.font.size.s,
      lineHeight: defaultTheme.font.height.l,
      '& > a': {
        textDecorationLine: 'underline',
      },
    },
    '& > a': {
      display: 'block',
      margin: `${defaultTheme.spacing.xxl} 0`,
    },
  }),
);

export const VerificationWrapper = styled(Wrapper)(() =>
  mq({
    '& > p': {
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.xxl,
    },
  }),
);

export const InProgressWrapper = styled(Wrapper)(() =>
  mq({
    '& > p': {
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.l,
    },
    '& > span': {
      fontSize: defaultTheme.font.size.s,
      lineHeight: defaultTheme.font.height.l,
    },
  }),
);

export const CreditDormantWrapper = styled.div(() =>
  mq({
    margin: `${defaultTheme.spacing.xxl} auto 0`,
    textAlign: 'center',
  }),
);

export const CreditDormantTitle = styled.div(() =>
  mq({
    fontWeight: 'bold',
    color: defaultTheme.text.error,
    fontSize: defaultTheme.font.size.l,
  }),
);

export const CreditDormantNote = styled.div(() =>
  mq({
    marginTop: defaultTheme.spacing.m,
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.m,
  }),
);

export const CreditDormantLink = styled.div(() =>
  mq({
    marginTop: defaultTheme.spacing.m,
    '& > a': {
      color: defaultTheme.text.gray,
      fontSize: defaultTheme.font.size.s,
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
  }),
);
